import { useState, useEffect } from 'react';
import { loadGA4Script } from '../utils/ga4';

export const usePublicSettings = () => {
  const [settings, setSettings] = useState({
    ga4_tracking_id: null,
    default_og_image: null,
    visitor_stats_image: null,
    monthly_visitors: null
  });
  const [isGA4Loaded, setIsGA4Loaded] = useState(false);

  useEffect(() => {
    const loadPublicSettings = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`);
        const data = await response.json();
        
        setSettings({
          ga4_tracking_id: data.ga4_tracking_id,
          default_og_image: data.default_og_image,
          visitor_stats_image: data.visitor_stats_image,
          monthly_visitors: data.monthly_visitors
        });
        
        if (data.ga4_tracking_id) {
          loadGA4Script(data.ga4_tracking_id, setIsGA4Loaded);
        }
      } catch (error) {
        console.error('Public beállítások betöltési hiba:', error);
      }
    };

    loadPublicSettings();
  }, []);

  return { settings, isGA4Loaded };
};
